import dynamic from 'next/dynamic';

const AccessCode = dynamic(
  () => import(/* webpackChunkName: "pbKpAccessCode" */ '../../../../components/AccessCode')
);

const pageBuilderComponents = {
  'access-code': AccessCode
};

export default pageBuilderComponents;
